import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TrackingViewComponent } from '../tracking-view/tracking-view.component';
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule, FormArray } from '@angular/forms';
// import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FilterPipe } from '../filter.pipe';
// import { AccordionModule } from '@syncfusion/ej2-angular-navigations';

@NgModule({
  declarations: [TrackingViewComponent,FilterPipe],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    FormsModule,
    // MultiSelectAllModule,
    ReactiveFormsModule,
    AngularMultiSelectModule,
    // AccordionModule
  ],
  exports: [
    TrackingViewComponent
  ],
  entryComponents: [
    //ReportViewComponent,
  ]
})
export class TrackingViewModuleModule { }
